/** ******** 账户及角色管理 ********* */

// 获取账户列表
export const getAccountList = {
  method: 'get',
  url: '/admin/manage/queryUserInfo.json'
};

// 获取角色选项下拉列表
// 0-普通角色，1-务员角色，2-分管角色，3-超管子账号
export const getRoleSelectList = {
  method: 'get',
  url: '/admin/salesmanRole/getSalesManRoleComboboxList.json'
};

// 新增账户
export const addAccount = {
  method: 'post',
  url: '/admin/manage/userInfoSave.json',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 新增角色管理
export const getRoleList = {
  method: 'get',
  url: '/admin/salesmanRole/get_data.json'
};

// 菜单列表树查询
export const getMenuTree = {
  method: 'get',
  url: '/admin/salesmanRole/getPcMenu.json'
};

export const getAppMenuTree = {
  url: '/admin/salesmanRole/getAppMenu.json',
  method: 'get'
};

// 添加角色
export const addRole = {
  url: '/admin/salesmanRole/saveRole.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除角色
export const delRole = {
  url: '/admin/salesmanRole/deleteRole.json',
  method: 'get'
};

// 获取业务员账号列表
export const getSalesmanList = {
  url: '/admin/salesman/get_data.json',
  method: 'get'
};

// 获取业务员详情
export const getSalesmanDetail = {
  url: '/admin/salesman/getSalesmanInfo/V2.json',
  method: 'get'
};

// 获取业务员角色类型
export const getSalesmanRoleTypeList = {
  url: '/admin/salesmanRole/getSalesManRoleComboboxList.json',
  method: 'post'
};

// 获取业务员类型
export const getSalesmanTypeList = {
  url: '/admin/salesman/getSalesmanTypeComboboxList.json',
  method: 'post'
};

// 获取发货方列表
export const getSupplierBranchList = {
  url: '/admin/salesman/getSupplierBranchCover',
  method: 'get',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 添加业务员
export const addSalesmanMan = {
  url: '/admin/salesman/mergeSalesman/v2',
  method: 'post'
};

// 编辑查询所属团队表格数据
export const getSalesmanSupplierInfo = {
  url: '/admin/salesman/getSalesmanSupplierInfo',
  method: 'get'
};

export const uploadSales = {
  url: '/admin/salesman/execlImportSalesman',
  method: 'post'
};

export const uploadFaceRecognitionInvite = {
  url: '/admin/salesman/execlImportFaceRecognitionInvite',
  method: 'post'
};

// 禁用业务员
export const disableSalesmanMan = {
  url: '/admin/salesman/updateSalesmanStatus',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 邀请人脸识别认证
export const inviteFaceRecognition = {
  url: '/admin/salesman/inviteFaceRecognition.json',
  method: 'post'
};

// 取消人脸识别认证邀请
export const cancelFaceRecognitionInvite = {
  url: '/admin/salesman/cancelFaceRecognitionInvite.json',
  method: 'post'
};

// 获取人脸识别认证通过记录
export const getFaceRecognitionSuccessRecords = {
  url: '/mobile/v2/supUserTodo/faceRecognitionSuccessRecords.json',
  method: 'get'
};

// 获取业务员注册申请列表
export const getSalesmanApplyList = {
  url: '/admin/userRegistApply/getUserRegistApplyList.json',
  method: 'get'
};

// 获取平台下拉项列表
export const getDictItemList = {
  url: '/basic/getDictItem.json',
  method: 'get'
};